// extracted by mini-css-extract-plugin
export default {"navCard":"fBGHuvzl"};